import { Pipe, PipeTransform } from '@angular/core';
import { UserOverview } from '../models/user.model';

@Pipe({
  name: 'filterUserTable'
})
export class FilterUserTablePipe implements PipeTransform {

    transform(users: UserOverview[], filterText: string) {
        if (users == null)
            return null;
        return users.filter(user => {
           if (user.FullName != null && user.FullName.toLowerCase().indexOf(filterText.toLowerCase()) !== -1)
              return true;
            else if (user.UserName != null && user.UserName.toLowerCase().indexOf(filterText.toLowerCase()) !== -1)
                return true;
            else if (user.Email != null && user.Email.toLowerCase().indexOf(filterText.toLowerCase()) !== -1)
                return true;
            else if (user.TeamName != null && user.TeamName.toLowerCase().indexOf(filterText.toLowerCase()) !== -1)
                return true;
            return false;
        });
  }

}
